import { ActionType, getType } from 'typesafe-actions';

import { UserSession, UserSettings } from '../../Models';
import { identify } from '../../utils/Analytics';
import * as actions from './actions';
import * as pagesActions from '../PagesHistory/actions';
import * as badgesActions from '../Badges/actions';
import { BadgeId } from '../Badges/Models';

export enum UserNotice {
  insightsPromoDidShow = 'insightsPromoDidShow',
}

type UserNotices = {
  [key in UserNotice]?: boolean;
};

export interface IUserProfileState {
  readonly userInfo: UserSession | null;
  readonly settings: UserSettings;
  readonly notices: UserNotices;
  readonly wasLoggedIn: boolean;
  readonly badges: ReadonlyArray<BadgeId>;
}

export const initialState: IUserProfileState = {
  userInfo: null,
  settings: {
    wordsGoal: 500,
  },
  notices: {},
  wasLoggedIn: false,
  badges: [],
};

type UserProfileActions =
  | ActionType<typeof actions>
  | ActionType<typeof pagesActions>
  | ActionType<typeof badgesActions>;

export default (state: Mutable<IUserProfileState> = initialState, action: UserProfileActions): IUserProfileState => {
  switch (action.type) {
    case getType(actions.updateUserProfileInfo): {
      identify(action.payload.email);
      state.userInfo = action.payload;
      state.settings = action.payload.settings || state.settings;
      state.badges = action.payload.badges || state.badges;
      state.wasLoggedIn = true;
      break;
    }
    case getType(pagesActions.pageSynced): {
      if (state.userInfo) {
        if (state.userInfo.subscription.trialAnalysisLeft > 0) {
          state.userInfo.subscription.trialAnalysisLeft--;
        }
      }
      break;
    }
    case getType(actions.updateUserSettings): {
      state.settings = action.payload;
      break;
    }
    case getType(actions.updateUserProfileFromExternalSource): {
      if (action.payload.userInfo) {
        identify(action.payload.userInfo.email);
      }

      return action.payload;
    }
    case getType(actions.clickUserProfileLogout): {
      state.userInfo = initialState.userInfo;
      state.settings = initialState.settings;
      state.notices = initialState.notices;
      state.badges = initialState.badges;
      break;
    }
    case getType(actions.setUserNotice): {
      state.notices[action.payload.type] = action.payload.value;
      break;
    }
    case getType(badgesActions.unlockBadge): {
      const badges = new Set(state.badges.concat(action.payload));
      state.badges = Array.from(badges);
      break;
    }
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/containers/UserProfile/reducer.ts